import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, InjectionToken, Injector } from '@angular/core';
import { SpinnerComponent } from '../components/spinner/spinner.component';

export const CONTAINER_DATA = new InjectionToken<{}>('CONTAINER_DATA');

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private overlayRef: OverlayRef = null;
  private spinnerComponentRef: any = null;

  constructor(private overlay: Overlay, private injector: Injector) { }

  show(message?: string) {
    try {
      if (!this.overlayRef) {
        // Create the overlay with proper positioning strategy to center it
        this.overlayRef = this.overlay.create({
          hasBackdrop: false,
          positionStrategy: this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically()
        });
      }
      if (!this.overlayRef.hasAttached()) {
        const spinnerOverlayPortal = new ComponentPortal(SpinnerComponent);
        this.spinnerComponentRef = this.overlayRef.attach(spinnerOverlayPortal);
        if (message) {
          this.spinnerComponentRef.instance.message = message;
        }
      } else {
        // Spinner is already attached, just update the message
        if (this.spinnerComponentRef && message) {
          this.spinnerComponentRef.instance.message = message;
        }
      }
    } catch (ex) {
      // handle error
      console.error('Error showing spinner:', ex);
    }
  }

  hide() {
    if (!!this.overlayRef) {
      this.overlayRef.detach();
      this.spinnerComponentRef = null;
    }
  }
}
